import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./utility/store";
import { Provider } from "react-redux";

// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import "./index.css";
const root = ReactDOM.createRoot(document.getElementById("root"));

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <App />,
//   },
//   {
//     path: "/home",
//     element: <h1>Hello world</h1>,
//   },
// ]);

root.render(
  <Provider store={store}>
    
      <App />
      {/* <RouterProvider router={router} /> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
